import { omitBy, isNil } from 'lodash';
import { RequestTypeType, SourceSiteType, StatusType } from 'src/models/quotation-request';

const model = (data: {
  requestedBy: string;
  sourceSite: SourceSiteType;
  status: StatusType;
  requestType: RequestTypeType;
  files: any[];
}) => {
  return omitBy(
    {
      quotation_request: {
        requestedBy: data.requestedBy,
        sourceSite: data.sourceSite,
        status: data.status,
        requestType: data.requestType,
      },
      files: data.files,
    },
    isNil,
  );
};

export default model;
